<template>
 <div class="card border-0">
     <div class="row justify-content-center ">
         <div class="col-md-12 pt-3">
             <p class="font-weight-bold pl-3 mb-4 sb-block-title">Basic Information</p>
         </div>
     </div>
     <div class="row justify-content-center pl-4 pr-4 pb-2">
         <div class="col-md-12" id="basic-info-form">
             <div class="form-group row">
                 <label for="height" class="col-sm-4 col-form-label">Height (In.)</label>
                 <div class="col-sm-8">
                     <input type="text" required class="form-control" id="height" name="height" v-model="info.height">
                 </div>
             </div>
             <div class="form-group row">
                 <label for="weight" class="col-sm-4 col-form-label">Weight (Lbs.)</label>
                 <div class="col-sm-8">
                     <input type="text" required class="form-control" id="weight" name="weight" v-model="info.weight">
                 </div>
             </div>
             <div class="form-group row">
                 <label for="bloodtype" class="col-sm-4 col-form-label">Bloodtype</label>
                 <div class="col-sm-8">
                     <select  required class="form-control" id="bloodtype" name="bloodtype" v-model="info.bloodtype">
                        <option value="">Please Select</option>
                         <option v-for="t in types" :value="t.blt_id">{{t.blt_type}}</option>
                     </select>
                 </div>
             </div>
             <div class="form-group row" v-if="false">
                 <label for="photo" class="col-sm-4 col-form-label">Profile Photo</label>
                 <div class="col-sm-8">
                     <input type="text" required class="form-control" id="photo" name="photo" v-model="info.photo">
                 </div>
             </div>
             <div class="form-group row">
                 <label for="dob" class="col-sm-4 col-form-label">Date of Birth</label>
                 <div class="col-sm-8">
                     <input type="date" required class="form-control" id="dob" name="dob" v-model="info.dob">
                 </div>
             </div>
             <div class="form-group row">
                 <label for="mobilenumber" class="col-sm-4 col-form-label">Mobile Phone</label>
                 <div class="col-sm-8">
                     <input type="text" required class="form-control" id="mobilenumber" name="mobilenumber" v-model="info.mobilenumber" @input="formatMobileNumber()">
                 </div>
             </div>
             <div class="form-group row">
                 <label for="homenumber" class="col-sm-4 col-form-label">Home Phone</label>
                 <div class="col-sm-8">
                     <input type="text" required class="form-control" id="homenumber" name="homenumber" v-model="info.homenumber" @input="formatHomeNumber()">
                 </div>
             </div>
             <div class="form-group row">
                 <label for="account_email" class="col-sm-4 col-form-label">Account Email</label>
                 <div class="col-sm-8">
                     <input type="email" required class="form-control" id="account_email" name="account_email" autocomplete="off" v-model="info.email">
                     <small class="text-danger small-hint">
                         This email is used for all account operations and notifications, this should be your "primary" email
                     </small>
                 </div>
             </div>
             <div class="form-group row">
                 <label for="address" class="col-sm-4 col-form-label">Address</label>
                 <div class="col-sm-8">
                     <input type="text" required class="form-control" id="address" name="address" v-model="info.address">
                 </div>
             </div>
             <div class="form-group row">
                 <label for="city" class="col-sm-4 col-form-label">City</label>
                 <div class="col-sm-8">
                     <input type="text" required class="form-control" id="city" name="city" v-model="info.city">
                 </div>
             </div>
             <div class="form-group row mb-0">
                 <button type="button" class="btn btn-primary" @click="updateUser">Update</button>
             </div>

         </div>
     </div>
 </div>
</template>

<script>
    export default {
        props:['userInfo','types'],
        mounted() {

        },
        created: function() {

        },
        data(){
            return {
                route: '/api/basic-info',
                info: this.userInfo
            }
        },
        methods:{
            formatMobileNumber() {
                var x = this.info.mobilenumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                this.info.mobilenumber = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            formatHomeNumber() {
                var x = this.info.homenumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                this.info.homenumber = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            updateUser(){
                this.$http.post(this.route, this.info)
                    .then(function(response) {
                        $('.has-error').removeClass('has-error')
                        $('.help-block').remove()
                        this.showModal=false;
                        if(response.bodyText=="1"){
                            this.$notify({
                                type: 'success',
                                title: 'Success',
                                text: 'Information Updated!'
                            });
                        }else{
                            this.$notify({
                                type: 'error',
                                title: 'Success',
                                text: response.bodyText
                            });
                        }
                    }, (response) => {
                        this._handleErrors(response.data, '#basic-info-form')
                    })
            },
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            }
        }

    }
</script>
